import { Model as o } from "../../../model.js";
class r extends o {
  constructor(t) {
    super(), this.status = t.status, this.containerId = t.containerId;
  }
}
export {
  r as GoogleTagManagerModel
};
//# sourceMappingURL=googleTagManager.model.js.map
